import PropTypes from 'prop-types';

const CompanyPropTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  businessId: PropTypes.number,
  business: PropTypes.any,
  companyType: PropTypes.string.isRequired,
};

const TicketCorporateCreditInformationPropTypes = {
  id: PropTypes.number.isRequired,

  name: PropTypes.string.isRequired,

  description: PropTypes.string,

  companyId: PropTypes.number.isRequired,

  company: PropTypes.shape(CompanyPropTypes),

  contractType: PropTypes.string.isRequired,

  initialBalance: PropTypes.number.isRequired,

  actualBalance: PropTypes.number.isRequired,

  creditDays: PropTypes.number,

  active: PropTypes.bool,

  createDate: PropTypes.number.isRequired,

  lastUpdate: PropTypes.number.isRequired,
};

export default TicketCorporateCreditInformationPropTypes;
